( function() {

    // ─────────────────────────────────────────────
    // Markdown helpers (bold, italic, links)
    // ─────────────────────────────────────────────
    function renderMarkdown(text) {
        if (!text) return '';
        return text
            .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
            .replace(/_[ \t]*(\S(?:.*?\S)?)[ \t]*_/g, '<em>$1</em>')
            .replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g,
                '<a href="$2" target="_blank" rel="noopener">$1</a>')
            .replace(/\n/g, '<br>');
    }

    // ─────────────────────────────────────────────
    // UI helpers
    // ─────────────────────────────────────────────
    function show(id) { document.getElementById(id).style.display = ''; }
    function hide(id) { document.getElementById(id).style.display = 'none'; }

    function toggleSection(sectionId) {
        const el = document.getElementById(sectionId);
        el.classList.toggle('open');
    }

    function tagHTML(text, cls) {
        return `<span class="filter-pill ${cls} s5 me-3 mb-3">${text}</span>`;
    }

    function actionCategoryTag(cat) {
        if (!cat) return '';
        const map = {
            'Eligibility Limits':                         'tag-cat-eligibility',
            'Privacy Concern/Improper Data Sharing':      'tag-cat-privacy',
            'Messaging Designed to Create a Chilling Effect': 'tag-cat-chilling',
            'Ending Funding for Needed Services':         'tag-cat-funding',
            'Adding Red Tape':                            'tag-cat-redtape',
            'Immigration Enforcement':                    'tag-cat-enforcement',
        };
        const cls = map[cat] || 'tag-other';
        return tagHTML(cat, cls);
    }

    function actionTypeTag(type) {
        if (!type) return '';
        const map = {
            'EO': ['Executive Order', 'tag-eo'],
            'Regulation': ['Regulation', 'tag-regulation'],
            'Guidance': ['Guidance', 'tag-guidance'],
            'Other': ['Other', 'tag-other'],
        };
        const [label, cls] = map[type] || [type, 'tag-other'];
        return tagHTML(label, cls);
    }

    function statusTag(status) {
        if (!status) return '';
        const map = {
            'In effect':             'tag-status-in-effect',
            'Partially in effect':   'tag-status-partial',
            'Not in effect':         'tag-status-not-in-effect',
        };
        const cls = map[status] || 'tag-other';
        return tagHTML(status, cls);
    }

    function dotClass(resourceType) {
        const map = {
            'Article': 'dot-article',
            'Court Document': 'dot-court',
            'Government Document': 'dot-government',
            'Statement': 'dot-statement',
            'Analysis': 'dot-analysis',
        };
        return map[resourceType] || 'dot-other';
    }

    function formatDate(dateStr) {
        if (!dateStr) return '';
        const d = new Date(dateStr + 'T12:00:00'); // noon to avoid tz edge cases
        return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    }

    // ─────────────────────────────────────────────
    // Render functions
    // ─────────────────────────────────────────────
    
    function updateSocialLinks(recordId) {
        // Add the action tracker's ID to the end of the social media share elements in
        // the page hero. The URLs inside each href are URL-encoded, so ?id=recordId
        // must be appended in encoded form (%3Fid%3D) as well
        const idParam = '%3Fid%3D' + encodeURIComponent(recordId);

        const selectors = [
            '.pif-hero-socials__link.email a',
            '.pif-hero-socials__link.facebook a',
            '.pif-hero-socials__link.linkedin a',
            '.pif-hero-socials__link.shortcut a',
        ];

        selectors.forEach(selector => {
            const el = document.querySelector(selector);
            if (el) el.href += idParam;
        });
    }

    function renderMeta(fields) {

        // I'd like to grab the 

        const bar = document.getElementById('meta-bar');
        let html = '';

        if (fields['Action Category']) {
            html += actionCategoryTag(fields['Action Category']);
        }
        if (fields['Action Type']) {
            html += actionTypeTag(fields['Action Type']);
        }
        if (fields['Status']) {
            html += statusTag(fields['Status']);
        }
        if (fields.litigation_internal === 'Yes') {
            html += tagHTML('Litigation', 'tag-litigation');
        }
        if (fields['Action Type'] === 'Regulation' && fields['Comments Open']) {
            html += tagHTML('📣 Open for comments', 'tag-comments');
        }
        const agencies = Array.isArray(fields['Agency']) ? fields['Agency'] : [];
        agencies.forEach(a => {
            html += tagHTML(a, 'tag tag-agency');
        });

        bar.innerHTML = html;
    }

    function renderUpdates(updates) {
        const countEl = document.getElementById('updates-count');
        const bodyEl  = document.getElementById('updates-body');

        countEl.textContent = '(' + updates.length + ')';
        if (updates.length > 0) countEl.classList.add('has-items');

        if (updates.length === 0) {
            bodyEl.innerHTML = '<p class="empty-note">No updates on record.</p>';
            return;
        }

        // Sort by date descending (newest first)
        updates.sort((a, b) => {
            const da = a.fields['Update Date'] || '';
            const db = b.fields['Update Date'] || '';
            return db.localeCompare(da);
        });

        bodyEl.innerHTML = updates.map(u => {
            const f = u.fields;
            const dateStr = f['Update Date'] ? formatDate(f['Update Date']) : '';
            const text = renderMarkdown(f['Update Text'] || f['Update Summary'] || '');
            return `
                <div class="update-item">
                    ${dateStr ? `<div class="update-date mb-1 s5 has-gray-600-color">${dateStr}</div>` : ''}
                    <div class="update-text b4">${text}</div>
                </div>`;
        }).join('');
    }

    function renderResources(resources) {
        const countEl = document.getElementById('resources-count');
        const bodyEl  = document.getElementById('resources-body');

        countEl.textContent = '(' + resources.length + ')';
        if (resources.length > 0) countEl.classList.add('has-items');

        if (resources.length === 0) {
            bodyEl.innerHTML = '<p class="empty-note">No resources on record.</p>';
            return;
        }

        // Sort by sort_order value, lowest first
        resources.sort((a, b) => {
            const sa = a.fields.sort_order ?? Infinity;
            const sb = b.fields.sort_order ?? Infinity;
            return sa - sb;
        });

        // Group by Resource Type
        const groups = {};
        const typeOrder = ['Comment Tool', 'Statement', 'Analysis', 'Court Document', 'Government Document', 'Article', 'Other'];
        const typeLabels = {
            'Comment Tool': 'Comment Tool',
            'Statement': 'Statements',
            'Analysis': 'Analysis',
            'Court Document': 'Court Documents',
            'Government Document': 'Government Documents',
            'Article': 'Articles',
            'Other': 'Other',
        };
        resources.forEach(r => {
            const type = r.fields['Resource Type'] || 'Other';
            if (!groups[type]) groups[type] = [];
            groups[type].push(r);
        });

        let html = '';
        typeOrder.forEach(type => {
            if (!groups[type]) return;
            html += `<div class="resource-type-group">
                <div class="resource-type-label s5">${typeLabels[type] || type}</div>`;
            groups[type].forEach(r => {
                const f = r.fields;
                const desc = renderMarkdown(f['Resource Description'] || f['Resource Summary'] || '');
                const url  = f['URL'] || '';
                const dot  = dotClass(f['Resource Type']);
                html += `
                    <div class="resource-item">
                        <div class="resource-type-dot ${dot}"></div>
                        <div class="resource-content">
                            <div class="resource-description b4">${desc}</div>
                        </div>
                    </div>`;
            });
            html += '</div>';
        });

        bodyEl.innerHTML = html;
    }

    function renderRelated(relatedNames) {
        if (!relatedNames || relatedNames.length === 0) return;

        const section = document.getElementById('related-accordion-section');
        const countEl = document.getElementById('related-count');
        const bodyEl  = document.getElementById('related-body');

        section.style.display = '';
        countEl.textContent = '(' + relatedNames.length + ')';
        countEl.classList.add('has-items');

        bodyEl.innerHTML = `<ul class="related-list ps-3">
            ${relatedNames.map(r => `<li><a href="?id=${r.id}">${r.title}</li></a>`).join('')}
        </ul>`;
    }

    // ─────────────────────────────────────────────
    // Main loader — reads from the WP-provided cache (PifTrackerDetail)
    // instead of making live Airtable API calls.
    // ─────────────────────────────────────────────
    function loadAction() {
        const cache = window.PifTrackerDetail || {};

        if (!cache.recordId) {
            hide('loading-state');
            hide('main');
            hide('action-date');
            document.getElementById('error-message').textContent =
                'No record ID provided. Add ?id=recXXXXXX to the URL.';
            show('error-state');
            return;
        }

        if (!cache.data) {
            hide('loading-state');
            hide('main');
            hide('action-date');
            document.getElementById('error-message').textContent =
                'Record not found in cache. ' +
                (cache.lastSync
                    ? 'Last synced: ' + cache.lastSync + '.'
                    : 'The cache has not been populated yet — run a manual sync in WP Admin > PIF Site Settings > Action Tracker.');
            show('error-state');
            return;
        }

        try {
            const { record, updates, resources, related } = cache.data;
            const f = record.fields;

            // ── Render ──
            document.title = (f['Short Title'] || f['Long Title'] || 'Action') + ' — Immigration & Benefits Tracker';

            updateSocialLinks(cache.recordId);

            renderMeta(f);

            let actionTitle = document.getElementById('action-title');
            if (actionTitle) {
                actionTitle.textContent = f['Short Title'] || f['Long Title'] || '(Untitled)';
            }

            if (f['Initial Date']) {
                let actionDate = document.getElementById('action-date');
                if (actionDate) {
                    actionDate.textContent = formatDate(f['Initial Date']);
                }
            }

            document.getElementById('action-description').innerHTML = renderMarkdown(f['Description'] || '');

            if (f['Current Status']) {
                document.getElementById('action-status').innerHTML = renderMarkdown(f['Current Status']);
                show('status-block');
            }

            renderUpdates(updates);
            renderResources(resources);

            if (related && related.length > 0) {
                renderRelated(related);
            }

            hide('loading-state');
            show('main');

            // Setup accordion click handlers
            document.querySelectorAll('.expand-header').forEach(function(section) {
                const sectionName = section.dataset.sectionName;
                if (sectionName) {
                    section.addEventListener('click', function() {
                        toggleSection(sectionName);
                    });
                }
            });

        } catch (err) {
            console.error(err);
            hide('loading-state');
            hide('main');
            hide('action-date');
            document.getElementById('error-message').textContent = 'Could not render record: ' + err.message;
            show('error-state');
        }
    }

    // ─────────────────────────────────────────────
    // Init
    // ─────────────────────────────────────────────
    document.addEventListener('DOMContentLoaded', loadAction);

})();